// Module
var code = "\r\n<template>\r\n    <div ref=\"tab_body\" class=\"tab-pane ${active ? 'active show' : ''} ${isFade ? 'fade' : ''}\" role=\"tab-panel\">\r\n        <slot></slot>\r\n    </div>\r\n</template>";
// Exports
export default code;